import styled from "@emotion/styled";
import {createContext, PropsWithChildren, useContext} from "react";

const Container = styled.div`
  border: 0;
  padding: 10px;
  position: absolute;
  top: 60px;
  bottom: 0;
  left: 0;
  pointer-events: none;

  & > * {
    pointer-events: auto;
  }
`;

const QuickPanelCloseContext = createContext<(() => void) | undefined>(undefined);

/** The enclosing quick panel's close, for a panel to put in its own header. */
export const useQuickPanelClose = () => useContext(QuickPanelCloseContext);

export type QuickPanelContainerProps = {
  onCloseClick?: () => void
}

/** Floats a map panel down the map's left edge; the panel draws its own close button from `useQuickPanelClose`. */
export const QuickPanelContainer = (props: PropsWithChildren<QuickPanelContainerProps>) => {
  const {onCloseClick, children} = props;
  return (
    <QuickPanelCloseContext.Provider value={onCloseClick}>
      <Container>
        <>
          {children}
        </>
      </Container>
    </QuickPanelCloseContext.Provider>
  )
}
